'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const localStorageHelper = require('dibs-browser-storage').localStorage;

class PortfolioStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);
        this._localItems = localStorageHelper.getItem('favoriteItems') || {};
    }

    getLocalItems() {
        return this._localItems;
    }

    canSaveLocally() {
        return Object.keys(this._localItems).length < 3;
    }

    localItemsCount() {
        return Object.keys(this._localItems).length;
    }

    saveItemToStorage({pk, vertical}) {

        this._localItems[pk] = {
            createdDate: new Date(),
            vertical
        };

        localStorageHelper.setItem('favoriteItems', this._localItems);
    }

    isItemInStorage({pk}) {
        return !!this._localItems[pk];
    }

    removeItemFromStorage({pk}) {
        delete this._localItems[pk];

        if (Object.keys(this._localItems).length) {
            localStorageHelper.setItem('favoriteItems', this._localItems);
        } else {
            this.clearItemsInStorage();
        }
    }

    clearItemsInStorage() {
        localStorageHelper.deleteItem('favoriteItems');
        this._localItems = {};
    }
}

PortfolioStore.handlers = {
    'favorite:item:storage:save': 'saveItemToStorage',
    'favorite:item:storage:clear': 'clearItemsInStorage',
    'favorite:item:storage:remove': 'removeItemFromStorage'
};

PortfolioStore.storeName = 'PortfolioStore';

module.exports = PortfolioStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/PortfolioStore.es.js